import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { DatePipe, DecimalPipe, ViewportScroller } from '@angular/common';
import { Observable, Subject, combineLatest, map, takeUntil } from 'rxjs';

import { MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { MyPurchaseForm } from 'src/app/shared/models/app-models/MyPurchaseForm.model';

import * as _ from 'lodash';

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { MatTabGroup } from '@angular/material/tabs';

import { MatExpansionPanel } from '@angular/material/expansion';
import { BudgetSummaryComponent } from './budget-summary/budget-summary.component';
import { PurchaseTypeMap } from 'src/app/shared/models/app-models/Approving.model';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
export interface IitemRequestTable {
  itemId: number;
  PurchaseItemId: string | null;
  MaterialSubGroupId: string | null;
  MaterialSubGroupNameId: string | null;
  ItemDescription: string;
  Quantity: number;
  UnitOfMeasurement: string;
  Currency: string;
  UnitPrice: string;
  UnitsPerQuantity: string;
  TotalAmount: string;
  PartModelNumber: string;
  PlannedDeliveryDate: Date;
}

@Component({
  selector: 'app-item-vendor',
  templateUrl: './item-vendor.component.html',
  styleUrls: ['./item-vendor.component.scss'],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {},
    },
    {
      provide: DatePipe,
    },
    {
      provide: DecimalPipe,
    },
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class ItemVendorComponent implements OnDestroy {
  @ViewChild('budgetSummaryPanel') expansionPanel!: MatExpansionPanel;
  @Input() isReadOnly: boolean = false;
  @Input() isLocked: boolean = true;
  destroy$: Subject<boolean> = new Subject<boolean>();
  RORequired: boolean = false;
  recieveCost: string = '0.0';
  permissionData$: Observable<any>
  purchaseTypeMap: Record<number, string> = PurchaseTypeMap
  @ViewChild('budgetSummaryTable') budgetSummaryComponent!: BudgetSummaryComponent
  //#endregion
  constructor(
    private scroller: ViewportScroller,
    private store: Store<{ form: MyPurchaseForm }>,
    private permissionService: PermissionsService
  ) {
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: MyPurchaseForm) => {
        this.RORequired = form.isProjectRORequired;
      });
    this.permissionData$ = this.permissionService.getService().pipe(takeUntil(this.destroy$))
  }
  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.unsubscribe()
  }
  selectPersonnelClick() {
    this.scroller.scrollToAnchor('budgetSummaryPanel');
    this.expansionPanel.open();
  }

  sendFinalItemCost(event: string) {
    this.recieveCost = event;
  }
}
